import { render, staticRenderFns } from "./ProdAdd.vue?vue&type=template&id=57d279da&scoped=true&"
import script from "./ProdAdd.vue?vue&type=script&lang=js&"
export * from "./ProdAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d279da",
  null
  
)

export default component.exports